import React, { useEffect } from "react";
import { useUser } from "../../utensils/UserContext";

const SnackTemplates = () => {
  const { user } = useUser();

  useEffect(() => {
    console.log("✅ SnackNewEvaluations cargado");
    if (user?.Email) {
      console.log(`📧 Usuario autenticado: ${user.Email}`);
    } else {
      console.warn("⚠️ No hay sesión iniciada correctamente.");
    }
  }, [user]);

  // Validación de sesión
  if (!user || !user.Email) {
    return (
      <p className="text-danger">No se ha iniciado sesión correctamente.</p>
    );
  }

  const encodedEmail = encodeURIComponent(user.Email);
  const evaluationUrl = `https://www.fisiofitnessapp.com/microapp/templates/index.html?token=XDF-AGF-LOI-UJH-YHR-RFT`;

  return (
    <div
      style={{
        height: "85vh",
        border: "1px solid #ccc",
        borderRadius: "8px",
        overflow: "hidden",
        padding: "8px",
      }}
    >
      <iframe
        src={evaluationUrl}
        title="Nuevo formulario de evaluación"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
};

export default SnackTemplates;
